import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  } from 'chart.js';
  
  import { Chart } from 'react-chartjs-2';
  
  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  );
  
  const GenericMultichart = ({title, labels, data1, dataset_label1, type1, backgroundColor1,
    data2, dataset_label2, type2}: any) => {
    
    const type = "bar"

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
          legend: {
            position: 'bottom' as const,
          },
          title: {
            display: true,
            text: title,
          },
      }
    }  
  
    // Para las barras  
    const data = {
      labels,
      datasets: [
        {
          type: type2,
          label: dataset_label2,
          data: data2,
          backgroundColor: '#2D5C92',
          borderColor: '#2D5C92',
          borderWidth: 2,
          borderDash: [5, 5],
          pointStyle: false
        },
        {
          type: type1,
          label: dataset_label1,
          data: data1,
          backgroundColor: '#a0a9b0',
          borderColor: 'gray',
          borderWidth: 1,
        },
      ],
  };
  
    return (<Chart type={type} data={data} options={options}/>)
  
  }
  
  export default GenericMultichart;